export default __webpack_public_path__ + "static/29111-f01abac8c5e0b6905c24e210f9670e21.jpg";